module.exports = __webpack_public_path__ + "static/media/voucher.2e1832b5.svg";